var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.dialog)?_c('create-content',{attrs:{"currentContents":_vm.currentContents,"enabled":_vm.dialog,"dialogTitle":_vm.dialogTitle,"type":_vm.type},on:{"closed":function($event){_vm.dialog = false},"submit":_vm.didTapSaveContent}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }